export default function Table() {
  let prevScrollTop = 0;
  let currentScrollTop = 0;
  let fxiTopHeader = document.querySelector(".fxi-top-header");
  let tableBtn1 = document.querySelectorAll(
    ".table_radio-button-label.table_col-one"
  );

  let tableBtn2 = document.querySelectorAll(
    ".table_radio-button-label.table_col-two"
  );

  window.addEventListener("scroll", function () {
    const a = window.scrollY;
    const b = fxiTopHeader && fxiTopHeader.clientHeight;

    currentScrollTop = a;

    if (prevScrollTop < currentScrollTop && a > b + b) {
      tableBtn1 &&
        tableBtn1[0] &&
        tableBtn1[0].classList.remove("table_radio-button-label-scroll-down");
      tableBtn2 &&
        tableBtn2[0] &&
        tableBtn2[0].classList.remove("table_radio-button-label-scroll-down");
    } else if (prevScrollTop > currentScrollTop && !(a <= b)) {
      tableBtn1[0] &&
        tableBtn2[0] &&
        tableBtn1[0].classList.add("table_radio-button-label-scroll-down");

      tableBtn2 &&
        tableBtn2[0] &&
        tableBtn2[0].classList.add("table_radio-button-label-scroll-down");
    }
    prevScrollTop = currentScrollTop;
  });
}
